import CareerBox from "./CareerBox"

export default CareerBox
